exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_AttachmentsContainer_2_nV9EiF14Rix_ugB5-hJA {\n  margin: 45px 40px 20px 40px;\n}\n\n.IA_AttachmentsAttachment_3B4XYv0K8BduJHbJeQg4MD {\n  display: flex;\n  align-items: center;\n}\n\n.IA_AttachmentsLink_6wfI-mTAirtOivQNmu_n {\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_AttachmentsContainer": "IA_AttachmentsContainer_2_nV9EiF14Rix_ugB5-hJA",
	"IA_AttachmentsAttachment": "IA_AttachmentsAttachment_3B4XYv0K8BduJHbJeQg4MD",
	"IA_AttachmentsLink": "IA_AttachmentsLink_6wfI-mTAirtOivQNmu_n"
};